import { ElementSource } from "chq";
import { GENERIC_ELEMENT } from "./constants";

const isStoryElement = (element: ElementSource): boolean => (
  element.name?.startsWith("media-") || element.name === GENERIC_ELEMENT.STORY || element.name?.includes("'s video")
);

export default isStoryElement;
